import { IconFont, SignTitle, SvgIcon, Warning } from '@/components'
import { Descriptions, Modal, Typography, Table } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { t } from '@/i18n'
import { useGetpackagelist, useGetpackagehash, useGetDownloadParams } from '../util'
export const DownloadKey = props => {
  const { switchChange, installation, installData } = props
  const [getpackagelist] = useGetpackagelist()
  const [getpackagehash] = useGetpackagehash()
  const [showHash, setShowHash] = useState({
    visible: false,
    packageid: null,
  })

  let [data, setData] = useState<any>([])
  let [groups, setGroups] = useState([])
  let [packageId, setPackageId] = useState(null)
  let [hashName, setHashName] = useState('')
  interface PackageList {
    name: string
    os: string
    os_version: string
    version: string
    os_architecture?: string
    id: string
    file_size: string
  }
  useEffect(() => {
    getpackagelist({})
      .then(res => {
        setData((data = res.data.package))
      })
      .catch(err => {})
  }, [])
  useEffect(() => {
    if (packageId) {
      getpackagehash({ package_id: packageId })
        .then(res => {
          setGroups((groups = res.data.hash))
        })
        .catch(err => {})
    }
  }, [packageId])

  //点击添加属性名
  const [activeIndex, setActiveIndex] = useState(0)
  const [packageList, setPackageList] = useState<PackageList[]>([])
  useEffect(() => {
    if (switchChange === 'windows') {
      const dataList = data.filter(
        item => item.os === 'Windows 64bit' || item.os === 'Windows 32bit',
      )
      setPackageList(dataList)
      checkPackage(dataList[0], 0)
    }
    if (switchChange === 'linux') {
      const dataList = data.filter(item => item.os === 'Linux .rpm' || item.os === 'Linux .deb')
      setPackageList(dataList)
      checkPackage(dataList[0], 0)
    }
    if (switchChange === 'uos') {
      const dataList = data.filter(item => item.os === 'UOS')
      setPackageList(dataList)
      checkPackage(dataList[0], 0)
    }
  }, [data, switchChange])
  const checkPackage = (item, index) => {
    console.log('item', item)
    setActiveIndex(index)
    installation(item?.os)
    installData(item)
  }
  return (
    <>
      {packageList?.map((item, index) =>
        switchChange === 'windows' ? (
          <Download key={index}>
            <FrameworkType os_architecture={item.os_architecture}>
              {item.os_architecture || 'X86'}
            </FrameworkType>
            <div
              className={`${'download-content'}`}
              style={{ border: activeIndex === index ? '1px solid #4238C9' : '' }}
              onClick={() => checkPackage(item, index)}
            >
              <div className="download-left">
                <div className="download-icon">
                  <SvgIcon name="clienticon" className="svg" style={{ marginTop: 10 }} />
                </div>
                <a
                  style={{ textDecoration: 'none' }}
                  className="download"
                  href={`${
                    process.env.NODE_ENV === 'dev' ? '/api' : ''
                  }/portal/agentClient/package/download?name=${item.name}&package_id=${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="client-icon">
                    <IconDownload type={'icon-xiazai2'} />
                    <div className="icon-text">
                      <p>{item.os}</p>
                    </div>
                  </div>
                </a>
              </div>
              <div
                style={{
                  width: '55%',
                  height: '90%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                }}
              >
                <Typography.Text
                  ellipsis={{ tooltip: true }}
                  className="text"
                  style={{ fontWeight: 600 }}
                >
                  {item.name}
                </Typography.Text>
                <div className="text">
                  {t('安装包大小：')}
                  {item.file_size}
                </div>
                <div className="text">
                  {t('版本号：')}
                  {item.version}
                </div>
                <div className="text">
                  <a
                    className="hash"
                    onClick={e => {
                      e.stopPropagation()
                      setPackageId((packageId = item.id))
                      setShowHash({ visible: true, packageid: item.id })
                      setHashName(item.name)
                    }}
                  >
                    {t('客户端哈希值')}
                  </a>
                </div>
              </div>
            </div>
          </Download>
        ) : switchChange === 'linux' ? (
          <Download key={item.id}>
            <FrameworkType os_architecture={item.os_architecture}>
              {item.os_architecture || 'X86'}
            </FrameworkType>
            <div
              className="download-content"
              style={{ border: activeIndex === index ? '1px solid #4238C9' : '' }}
              onClick={() => checkPackage(item, index)}
            >
              <div className="download-left">
                <div className="download-icon">
                  <SvgIcon name="linux" className="svg" style={{ marginTop: 10 }} />
                </div>
                <a
                  style={{ textDecoration: 'none' }}
                  className="download"
                  href={`${
                    process.env.NODE_ENV === 'dev' ? '/api' : ''
                  }/portal/agentClient/package/download?name=${item.name}&package_id=${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="client-icon">
                    <IconDownload type={'icon-xiazai2'} />
                    <div className="icon-text">
                      <p>{item.os}</p>
                    </div>
                  </div>
                </a>
              </div>
              <div
                style={{
                  width: '55%',
                  height: '90%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                }}
              >
                <Typography.Text
                  ellipsis={{ tooltip: true }}
                  style={{ fontWeight: 600, width: '100%' }}
                >
                  {item.name}
                </Typography.Text>
                <div className="text">
                  {t('安装包大小：')}
                  {item.file_size}
                </div>
                <div className="text">
                  {t('版本号：')}
                  {item.version}
                </div>
                <div className="text">
                  <a
                    className="hash"
                    onClick={e => {
                      e.stopPropagation()
                      setPackageId((packageId = item.id))
                      setShowHash({ visible: true, packageid: item.id })
                      setHashName(item.name)
                    }}
                  >
                    {t('客户端哈希值')}
                  </a>
                </div>
              </div>
            </div>
          </Download>
        ) : (
          item.os === 'UOS' && (
            <Download key={item.id}>
              <FrameworkType os_architecture={item.os_architecture}>
                {item.os_architecture || 'X86'}
              </FrameworkType>
              <div
                className={`${'download-content'}`}
                style={{ border: activeIndex === index ? '1px solid #4238C9' : '' }}
                onClick={() => checkPackage(item, index)}
              >
                <div className="download-left">
                  <div className="download-icon">
                    <SvgIcon name="uos_icon" className="svg" style={{ marginTop: 10 }} />
                  </div>
                  <a
                    style={{ textDecoration: 'none' }}
                    className="download"
                    href={`${
                      process.env.NODE_ENV === 'dev' ? '/api' : ''
                    }/portal/agentClient/package/download?name=${item.name}&package_id=${item.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="client-icon">
                      <IconDownload type={'icon-xiazai2'} />
                      <div className="icon-text">
                        <p>{item.os}</p>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  style={{
                    width: '55%',
                    height: '90%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-around',
                  }}
                >
                  <Typography.Text
                    ellipsis={{ tooltip: true }}
                    className="text"
                    style={{ fontWeight: 600 }}
                  >
                    {item.name}
                  </Typography.Text>
                  <div className="text">安装包大小：{item.file_size}</div>
                  <div className="text">版本号：{item.version}</div>
                  <div className="text">
                    <a
                      className="hash"
                      onClick={e => {
                        e.stopPropagation()
                        setPackageId((packageId = item.id))
                        setShowHash({ visible: true, packageid: item.id })
                        setHashName(item.name)
                      }}
                    >
                      客户端哈希值
                    </a>
                  </div>
                </div>
              </div>
            </Download>
          )
        ),
      )}

      <Modal
        width={670}
        title={<SignTitle show>{hashName}</SignTitle>}
        centered
        open={showHash.visible}
        onCancel={() => {
          setShowHash({ visible: false, packageid: null })
        }}
        footer={null}
      >
        <Warning
          style={{ width: '100%', marginBottom: 16 }}
          text={t('注意：为了软件正常运行，请在杀毒软件/EDR等终端保护设施添加例外白名单')}
        />
        <Title>{t('客户端哈希值')}</Title>
        <div style={{ marginBottom: '16px' }}>
          {groups?.map((hash, ind) => (
            <HashItem key={ind}>
              <div className="title">
                <IconFont type="icon-exe" className="icon" />
                {hash.file_type === 2 && <IconFont type="icon-msi" className="icon" />}
                {hash.file_type === 3 && <IconFont type="icon-dll" className="icon" />}
                <div>{hash.name}</div>
              </div>
              {Object.keys(hash).map((key, index) => {
                const arr = ['id', 'file_type', 'name', 'type']
                if (arr.includes(key)) return null
                return (
                  <div style={{ display: 'flex', gap: '8px' }} key={index}>
                    <span style={{ width: '75px', textAlign: 'left', display: 'inline-block' }}>
                      {key.includes('sha')
                        ? key.toUpperCase().split('SHA').join('SHA-')
                        : key.toUpperCase()}
                      {t('：')}
                    </span>
                    <Typography.Paragraph
                      key={index}
                      copyable={{
                        icon: [<IconFont className="icon" key={1} type="icon-fuzhi" />],
                        text: hash[key],
                      }}
                    />
                    {<div style={{ width: '90%' }}>{hash[key]}</div>}
                  </div>
                )
              })}
            </HashItem>
          ))}
        </div>
      </Modal>
    </>
  )
}

export const OperateSystem = props => {
  let [data, setData] = useState<any>([])
  const [getpackagelist] = useGetpackagelist()
  useEffect(() => {
    getpackagelist({})
      .then(res => {
        setData((data = res.data.package))
      })
      .catch(err => {})
  }, [])
  const { switchChange } = props
  return switchChange === 'windows' ? (
    <TableBox>
      <span style={{ display: 'inline-block', marginBottom: '16px' }}>{t('支持操作系统')}</span>
      <Table
        dataSource={data
          .filter(item => item.os.includes('Windows'))
          .map((item, index) => ({ ...item, key: index }))}
        columns={[
          {
            title: t('架构'),
            dataIndex: 'os_architecture',
            key: 'os_architecture',
          },
          {
            title: t('Windows 版本'),
            dataIndex: 'os',
            key: 'os',
          },
          {
            title: t('支持的Windows版本'),
            dataIndex: 'os_version',
            key: 'os_version',
          },
        ]}
        pagination={false}
        showHeader={false}
        bordered
      />
    </TableBox>
  ) : switchChange === 'linux' ? (
    <TableBox>
      <span style={{ display: 'inline-block', marginBottom: '16px' }}>{t('支持操作系统')}</span>
      <Table
        dataSource={data
          .filter(item => item.os.includes('Linux'))
          .map((item, index) => ({ ...item, key: index }))}
        columns={[
          {
            title: t('架构'),
            dataIndex: 'os_architecture',
            key: 'os_architecture',
          },
          {
            title: t('Windows 版本'),
            dataIndex: 'os',
            key: 'os',
          },
          {
            title: t('支持的Windows版本'),
            dataIndex: 'os_version',
            key: 'os_version',
          },
        ]}
        pagination={false}
        showHeader={false}
        bordered
      />
    </TableBox>
  ) : (
    <TableBox>
      <span style={{ display: 'inline-block', marginBottom: '16px' }}>{t('支持操作系统')}</span>
      <Table
        dataSource={data
          .filter(item => item.os.includes('UOS'))
          .map((item, index) => ({ ...item, key: index }))}
        columns={[
          {
            title: t('架构'),
            dataIndex: 'os_architecture',
            key: 'os_architecture',
          },
          {
            title: t('Windows 版本'),
            dataIndex: 'os',
            key: 'os',
          },
          {
            title: t('支持的Windows版本'),
            dataIndex: 'os_version',
            key: 'os_version',
          },
        ]}
        pagination={false}
        showHeader={false}
        bordered
      />
    </TableBox>
  )
}
const IconDownload = styled(IconFont)`
  color: #666666;
  font-size: 18px;
  margin-right: 12px;
  transform: skewX(20deg);
  &:hover {
    color: #2973ff;
  }
`
const TableBox = styled.div`
  table {
    border-rop: none;
    td {
      border: 0;
      border-radius: 0;
    }
    td:hover {
      background: #fafafa;
    }
  }
  .ant-table-tbody > tr.ant-table-row:hover > td:nth-child(1)::after {
    display: none;
  }
  .ant-table-tbody > tr > td {
    background: #f7f7f7;
    color: #666 !important;
    border-top: 0 !important;
    border-bottom: 1px solid #ededed !important;
    border-right: 1px solid #ededed !important;
    text-align: center;
  }
  .ant-table-tbody > tr > td:first-child {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
  .ant-table-tbody > tr > td:last-child {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
`

const FrameworkType = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 2px;
  font-size: 12px;
  z-index: 1;
  top: 1px;
  left: 1px;
  width: 38px;
  height: 18px;
  background: ${props => (props.os_architecture === 'X86' ? '#D2E9EE' : '#DCDBF0')};
  color: ${props => (props.os_architecture === 'X86' ? '#2090A8' : '#4C45B5')};
  border-radius: 50px 10px 100px 6px;
`
const Download = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  .download-content {
    height: 104px;
    width: 500px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 16px;
    &:hover {
      box-shadow: 0px 4px 12px 0px rgba(27, 42, 81, 0.15);
    }
    .download-left {
      width: 35%;
      height: 90%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .download-icon {
        width: 100%;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        .svg {
          width: 40px;
          height: 40px;
        }
      }
    }
    .text {
      white-space: nowrap;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      line-height: 1.2;
    }
    .hash {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .download-content-borde {
    border: 1px solid red;
  }
  .client-icon {
    width: 90%;
    height: 40px;
    justify-content: center;
    background-color: #f1f3f8;
    transform: skewX(-20deg);
    margin-left: 13px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    transition: all 0.5s;
    &:hover {
      background-color: #4238c9;
      .anticon {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
  .icon-download {
    transform: skewX(20deg);
  }
  .icon-text {
    transform: skewX(20deg);

    p {
      font-size: 12px;
      margin-bottom: 3px;
      color: #666;
    }
  }
`
const HashItem = styled.div`
  background-color: #f7f7f7;
  padding-left: 12px;
  padding-top: 10px;
  padding-bottom: 2px;
  margin-bottom: 10px;
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .icon {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text {
    color: #666666;
    margin-bottom: 10px;
    word-break: break-all;
    .icon {
      color: #666666;
    }
  }
`

const Title = styled.div`
  width: 100%;
  height: 32px;
  margin: 0px 0 -2px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
`
